import React from 'react'
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Divider, Typography, Avatar, Grid } from '@material-ui/core'
import {
  Dashboard as DashboardIcon,
  Movie as MovieIcon,
  Games as GamesIcon,
  Lock as LockIcon,
} from '@material-ui/icons'
import Cookie from 'js-cookie'
import { useHistory } from 'react-router-dom'
import useStyles from './styles'
import { useStore } from '../../context/Context'

const DrawerPermanent = () => {
  const classes = useStyles()
  const history = useHistory()
  const initialName = Cookie.get('name') === undefined ? '' : Cookie.get('name').split(' ').map(s => s[0]).join('')
  const { selectedDrawer, setSelectedDrawer } = useStore()

  const menus = [
    { label: 'Dashboard', icon: <DashboardIcon />, link: '/dashboard' },
    { label: 'Movies Database', icon: <MovieIcon />, link: '/moviesDb' },
    { label: 'Games Database', icon: <GamesIcon />, link: '/gamesDb' },
    { label: 'Change Password', icon: <LockIcon />, link: '/changePassword' },
  ]

  return (
    <Drawer
      className={classes.drawer}
      variant="permanent"
      classes={{
        paper: classes.drawerPaper,
      }}
      anchor="left"
    >
      <div className={classes.toolbar} >
        <Typography variant="h5" className={classes.title}>
          GAM<span className={classes.primaryText}>MOVIES</span>
        </Typography>
      </div>
      <div className={classes.drawerContainer}>
        <Grid container justifyContent="center" alignItems="center" direction="column" style={{ marginBottom: '1em' }}>
          <Grid item>
            <Avatar
              alt="avatar"
              className={classes.avatar}
            >
              {initialName}
            </Avatar>
          </Grid>
          <Grid item style={{ marginTop: '0.5em' }}>
            <Typography variant="h6" style={{ textTransform: 'uppercase' }}>{Cookie.get('name')}</Typography>
          </Grid>
        </Grid>
        <Divider />
        <List>
          {menus.map((item, index) => (
            <ListItem
              key={index}
              button
              classes={{ selected: classes.selected }}
              selected={index === selectedDrawer}
              onClick={() => {
                setSelectedDrawer(index)
                history.push(item.link)
              }}
            >
              <ListItemIcon className={index === selectedDrawer ? classes.labelActive : classes.labelUnactive}>{item.icon}</ListItemIcon>
              <ListItemText primaryTypographyProps={{ className: `${classes.label} ${index === selectedDrawer ? classes.labelActive : classes.labelUnactive}` }} primary={item.label} />
            </ListItem>
          ))}
        </List>
      </div>
    </Drawer>
  )
}

export default DrawerPermanent